import type { AIModel, AIProvider } from '../types/enums.ts'
import { AI_MODELS, MODEL_CREDIT_COST } from '../types/enums.ts'

export function getProvider(model: AIModel): AIProvider {
  if (model.startsWith('claude')) return 'anthropic'
  if (model.startsWith('gpt') || model.startsWith('o')) return 'openai'
  if (model.startsWith('gemini')) return 'google'
  return 'perplexity'
}

/** Total credit cost for a job: prompts × sum of per-model costs */
export function computeJobCreditCost(promptCount: number, models: AIModel[]): number {
  return models.reduce((sum, m) => sum + MODEL_CREDIT_COST[m] * promptCount, 0)
}

/** Display label for a model variant */
export const MODEL_LABELS: Record<AIModel, string> = {
  'claude-haiku':         'Claude Haiku',
  'claude-sonnet':        'Claude Sonnet',
  'claude-opus':          'Claude Opus',
  'gpt-4o-mini':          'GPT-4o mini',
  'gpt-4.1':              'GPT-4.1',
  'gemini-2.5-flash':     'Gemini 2.5 Flash',
  'gemini-2.5-pro':       'Gemini 2.5 Pro',
  'perplexity-sonar':     'Sonar',
  'perplexity-sonar-pro': 'Sonar Pro',
}

/** Display label for a provider */
export const PROVIDER_LABELS: Record<AIProvider, string> = {
  anthropic:  'Anthropic',
  openai:     'OpenAI',
  google:     'Google',
  perplexity: 'Perplexity AI',
}

/** Tier display label for upgrade badges */
export const TIER_LABELS_SHORT: Record<string, string> = {
  free:   'FREE',
  pro:    'PRO',
  agency: 'AGENCY',
}

/** All models grouped by provider, in display order */
export function getModelsByProvider(): Record<AIProvider, AIModel[]> {
  const result: Record<AIProvider, AIModel[]> = {
    anthropic: [], openai: [], google: [], perplexity: [],
  }
  for (const model of AI_MODELS) {
    result[getProvider(model)].push(model)
  }
  return result
}
